import React from "react"
import PropTypes from "prop-types"
import makeStyles from "@material-ui/core/styles/makeStyles"
import Box from "@material-ui/core/Box"

const dummyvideoSrcUrl = "https://www.youtube.com/embed/ff4fgQxPaO0"

const useStyles = makeStyles(theme => ({
  videoWrapper: {
    position: "relative",
    paddingBottom: "56.25%" /* 16:9 -- 16/9=0.5925*/,
    paddingTop: "25px",
    height: 0,
    boxShadow: "-2px 0px 6px rgba(0,0,0,0.1), 2px 16px 24px rgba(0,0,0,0.1) ",
    background: "#000",
  },
  iframe2: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
}))

export default function Video({ title, videoSrcUrl }) {
  const classes = useStyles()

  return (
    <Box className={classes.videoWrapper}>
      <iframe
        src={videoSrcUrl || dummyvideoSrcUrl}
        title={title}
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; allowfullscreen"
        frameBorder="0"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        allowFullScreen={true}
        className={classes.iframe2}
        width="560"
        height="349"
      />
    </Box>
  )
}

Video.defaultProps = {
  title: "demo",
  videoSrcUrl: "https://www.youtube.com/embed/ff4fgQxPaO0",
}

Video.propTypes = {
  title: PropTypes.string.isRequired,
  videoSrcUrl: PropTypes.string,
}
